import { getTrackingCheckpointDecorationStyles } from './TrackingCheckpointDecorationStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { TrackingCheckpointDecorationIcon } from '../TrackingCheckpointDecorationIcon/TrackingCheckpointDecorationIcon.js';

function TrackingCheckpointDecoration(_ref) {
  let {
    hasDecorativeLine = true,
    isInitialCheckpoint,
    isLatestCheckpoint,
    ...otherProps
  } = _ref;
  return jsx("span", {
    css: getTrackingCheckpointDecorationStyles(hasDecorativeLine),
    ...otherProps,
    children: jsx(TrackingCheckpointDecorationIcon, {
      isInitialCheckpoint: isInitialCheckpoint,
      isLatestCheckpoint: isLatestCheckpoint
    })
  });
}

export { TrackingCheckpointDecoration };
//# sourceMappingURL=TrackingCheckpointDecoration.js.map
